type StatTileProps = {
	label: string;
	value: string;
};

const StatTile: React.FC<StatTileProps> = ({ label, value }) => (
	<div className="flex flex-col gap-1 rounded-xl border border-border-soft bg-surface p-5">
		<span className="text-xs uppercase tracking-wide text-muted">{label}</span>
		<span className="text-3xl font-bold text-foreground">{value}</span>
	</div>
);

export default StatTile;
